export * from './shipping-posted-container.component';
